import {IApiBusinessProfileProto, space} from "../../compiled";
import BusinessProfileProto = space.kenko.proto.BusinessProfileProto;

type Props = {
  business: IApiBusinessProfileProto | undefined,
  onSelect: (type: 'appt' | 'class') => void;
}

export const ChooseBookingType = (props: Props) => {

  return <div style={{display: 'flex', flexDirection: "column", textAlign: 'start'}}>
    <h3>Select Booking Type</h3>

    {props.business?.offersAppointments &&
        <button className={'BookingOverlaySelectable'} onClick={() => {
          props.onSelect('appt')
        }}>
          <div><b>Individual appointment</b></div>
          <div>1:1 session for yourself</div>
        </button>
    }

    {props.business?.offersClasses &&
        <button className={'BookingOverlaySelectable'} onClick={() => {
          props.onSelect('class')
        }}>
          <div><b>Group classes</b></div>
          <div>Join a class with others for a shared experience</div>
        </button>
    }

    {!props.business?.offersClasses && !props.business?.offersAppointments &&
        <div>This provider is not currently available for booking</div>
    }
  </div>
}